import { RoleChangeSubject } from "@custom-types/member-types";
import { Box } from "@mui/material";
import {
  DEFAULT_FONT_FAMILY_ITALIC,
  DEFAULT_INPUT_FONT_SIZE,
} from "@styles/common-styles";

interface Props {
  /** The role that the member was changed to, e.g. Project Manager */
  newRole: string;

  /** The role that the member was tried to changed to, e.g. Member */
  intendedRole: string;

  /** Why the role change was only partial */
  roleSubject: RoleChangeSubject;
}

/** Maps each role-change subject to a message explaining why the role change was only partial */
const reasonMessages: Record<RoleChangeSubject, (newRole: string) => string> = {
  group: (newRole) =>
    `The role could not be fully changed because the member is the ${newRole?.toLocaleLowerCase()} of a group.`,
  team: (newRole) =>
    `The role could not be fully changed because the member has the ${newRole?.toLocaleLowerCase()} role through a team.`,
};

/** Helper function to generate the message about removing the member from the group/team */
function getRemovalMessage(roleSubject: RoleChangeSubject): string {
  return `please remove the member from the ${roleSubject} first.`;
}

export function RolePartiallyChanged({
  intendedRole,
  newRole,
  roleSubject,
}: Props): JSX.Element {
  return (
    <Box
      component="div"
      sx={{
        fontSize: DEFAULT_INPUT_FONT_SIZE,
      }}
    >
      {reasonMessages[roleSubject](newRole)}
      <br />
      To change the role to
      <Box
        component="span"
        sx={{
          fontFamily: DEFAULT_FONT_FAMILY_ITALIC,
        }}
      >
        {" "}
        {intendedRole}
        {", "}
      </Box>
      {getRemovalMessage(roleSubject)}
    </Box>
  );
}
